import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  min-height: 154px;
`;

const LoaderHolder = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Hider = styled.div<{ hide: boolean }>`
  ${({ hide }) =>
    hide
      ? css`
          position: relative;
          opacity: 0.5;

          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 100;
            cursor: progress;
          }
        `
      : null};
`;

export const HideContentWithLoaderStyles = {
  Wrapper,
  LoaderHolder,
  Hider,
};
